import CatMessage from './CatMessage';

export default CatMessage;
